// extracted by mini-css-extract-plugin
export default {"root":"_eEltm","title":"wI1RT3","arrowButton":"UvGqmB","arrowIcon":"VcWv_R","arrowIconStateClose":"qcoFZe"};